export default __webpack_public_path__ + "static/media/map-tile-vault.8f807f77.svg";